import React from 'react';
import { useLocation } from 'react-router-dom';
import { ACCOUNT_GONE_PARAM, useAuthContext } from '../contexts/AuthContext';
import { APP_CONFIG } from '../config/AppConfig';

export const formatDeletionDate = iso => {
  const date = new Date(iso);
  return Number.isNaN(date.getTime())
    ? null
    : date.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
};

/**
 * Signed in to an account inside its 30-day deletion window: say so, and send the viewer to
 * bkfc.com/account to restore it (account management lives only there). After the window: say it
 * is gone.
 */
const AccountDeletionBanner = () => {
  const { deletion, isAuthenticated } = useAuthContext();
  const { search } = useLocation();
  const box = 'bg-red-900/40 border-b border-red-500/40 px-4 py-3 text-center';

  if (isAuthenticated) {
    if (deletion?.state !== 'scheduled') {
      return null;
    }
    const date = formatDeletionDate(deletion.undo_until);
    return (
      <div role="alert" className={box}>
        <p className="font-body text-sm text-white">
          Your account is scheduled for deletion{date ? ` on ${date}` : ''}. To keep it, sign in at{' '}
          <a
            href={APP_CONFIG.ACCOUNT_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-accent underline"
          >
            bkfc.com/account
          </a>{' '}
          and choose Restore My Account.
        </p>
      </div>
    );
  }

  if (new URLSearchParams(search).has(ACCOUNT_GONE_PARAM)) {
    return (
      <div role="status" className={box}>
        <p className="font-body text-sm text-white">This account has been deleted.</p>
      </div>
    );
  }
  return null;
};

export default AccountDeletionBanner;
